export interface TruncatedPath<T> {
  leading: T[];
  hidden: T[];
  trailing: T[];
  isTruncated: boolean;
}

export const truncatePath = <T>(
  items: T[],
  headCount: number,
  tailCount: number,
): TruncatedPath<T> => {
  if (items.length <= headCount + tailCount) {
    return { leading: items, hidden: [], trailing: [], isTruncated: false };
  }

  return {
    leading: items.slice(0, headCount),
    hidden: items.slice(headCount, items.length - tailCount),
    trailing: items.slice(items.length - tailCount),
    isTruncated: true,
  };
};
